/*
Akhila 03/06/2023 3225733165 Added Form and Table
Guru Prasad 03/06/2023 3225733165 Fixed Buttons issue
Raghu 03/09/2023 3225733165 added new class name for input fields
Rohini 03/17/2023 3225733165 fixed alignments in responsive
Prakash 08/05/2023 3225733165 add theming classname.

*/

import React, { useState, useContext } from 'react';
import { Form, Formik } from 'formik';
import { Button, TextField } from '@material-ui/core';
import { ThemeContext } from '../../../themes/ThemeProvider';
import Owned from './Owned';

const OwnedForm = ({ value }) => {
  const { reusableInputStyles } = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const initialValues = {
    workQueueName: '',
    workQueueDescription: '',
  };
  const handleSubmit = (data) => {
    setSubmit(true);
    setSearchData(data);
  };

  return (
    <>
      <div>
        <Formik
          onSubmit={(data) => handleSubmit(data)}
          initialValues={initialValues}
          enableReinitialize
        >
          {(props) => {
            const { values, handleChange, handleReset, handleBlur } = props;
            return (
              <div>
                <Form autoComplete="off" noValidate>
                  <div className="form-row standard-field-textfields align-items-center new-standard-textfields">
                    <div className="col-md-4 col-lg-4 col-xl-3 form-group">
                      <TextField
                        className={` ${classes.labelName}`}
                        variant="outlined"
                        margin="dense"
                        name="workQueueName"
                        label="Work Queue Name"
                        value={values.workQueueName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder={`Enter Work Queue Name`}
                        fullWidth
                      />
                    </div>
                    <div className="col-md-4 col-lg-4 col-xl-3 form-group">
                      <TextField
                        className={` ${classes.labelName}`}
                        margin="dense"
                        variant="outlined"
                        name="workQueueDescription"
                        placeholder={`Enter Work Queue Description`}
                        label=" Work Queue Description"
                        value={values.workQueueDescription}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </div>
                    <div className="col-md-3 col-lg-3 col-xl-3 form-group ">
                      <div className="d-flex justify-content-md-start justify-content-lg-center justify-content-xl-start">
                        <Button
                          variant="outlined"
                          className={`reset-btn mr-1 ${classes.buttonRoot}`}
                          onClick={() => {
                            setSubmit(true);
                            handleReset();
                            setSearchData(initialValues);
                          }}
                        >
                          Reset
                        </Button>
                        <Button
                          variant="outlined"
                          type="submit"
                          className={`search-btn ml-1 ${classes.buttonRoot}`}
                        >
                          Search
                        </Button>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            );
          }}
        </Formik>
        <Owned searchData={searchData} submit={submit} value={value} setSubmit={setSubmit} />
      </div>
    </>
  );
};

export default OwnedForm;
